/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { isNumber, isString } from 'remeda'
import styled, { css } from 'styled-components'
import type { TitleProps } from './SansTitle.types'

export const Title = styled.h1<TitleProps>`
  font-family: ${({ theme }) => {
    return theme.fonts.brand
  }};
  line-height: 125%;
  font-weight: ${({ fontWeight }) => {
    return fontWeight ?? '500'
  }};
  font-style: ${({ fontStyle }) => {
    return fontStyle ?? 'normal'
  }};
  letter-spacing: ${({ tracking }) => {
    return tracking === 'wide' ? '2px' : '0'
  }};
  text-transform: uppercase;
  margin: ${({ margin }) => {
    if (isNumber(margin)) {
      return `${margin}px`
    }

    if (isString(margin)) {
      return margin
    }

    return '0'
  }};
  padding: ${({ padding }) => {
    if (isNumber(padding)) {
      return `${padding}px`
    }

    if (isString(padding)) {
      return padding
    }

    return '0'
  }};

  ${({ underline }) => {
    return (
      underline &&
      css`
        text-decoration: underline;
      `
    )
  }}

  ${({ center }) => {
    return (
      center &&
      css`
        text-align: center;
      `
    )
  }}

  ${({ theme, color }) => {
    switch (color) {
      case 'primary': {
        return css`
          color: ${theme.colors.primary};
        `
      }
      case 'light': {
        return css`
          color: ${theme.colors.primaryLight};
        `
      }
      case 'white': {
        return css`
          color: ${theme.colors.text.secondary};
        `
      }
      case 'gray': {
        return css`
          color: ${theme.colors.hover};
        `
      }
      default: {
        return css`
          color: ${theme.colors.text.primary};
        `
      }
    }
  }}

  p {
    font-size: inherit;
    line-height: inherit;
    margin-bottom: 0;
  }

  ${({ size }) => {
    switch (size) {
      case 'xs': {
        return css`
          font-size: 14px;
        `
      }
      case 'sm': {
        return css`
          font-size: 16px;
        `
      }
      case 'md': {
        return css`
          font-size: 25px;
        `
      }
      default: {
        return css`
          font-size: 20px;
        `
      }
    }
  }}
`
